import { ReactComponent as DarkGreenTickIcon } from "shared/assets/Icons/ticks/dark-green.svg";
import { ReactComponent as GreenTickIcon } from "shared/assets/Icons/ticks/green.svg";
import { ReactComponent as OrangeTickIcon } from "shared/assets/Icons/ticks/orange.svg";
import { ReactComponent as RedTickIcon } from "shared/assets/Icons/ticks/red.svg";
import { ReactComponent as DarkRedTickIcon } from "shared/assets/Icons/ticks/dark-red.svg";
import { ReactComponent as NoTickIcon } from "shared/assets/Icons/ticks/no-tick.svg";

export const VerySadTickIcon = () => <DarkRedTickIcon />;
export const SadTickIcon = () => <RedTickIcon />;
export const NeutralTickIcon = () => <OrangeTickIcon />;
export const HappyTickIcon = () => <GreenTickIcon />;
export const VeryHappyTickIcon = () => <DarkGreenTickIcon />;
export const NullTickIcon = () => <NoTickIcon />;
